import { useEffect, useState } from "react";
import { AlertTriangle, Info, X } from "lucide-react";
import { useTranslation } from "react-i18next";

// Banner configurable polo admin (ver pestana "Sistema").
// Lese de /api/banner cada 60s; non bloquea o render do resto da app.
// Pódese ocultar localmente (sessionStorage) por sesión.
export default function GlobalBanner() {
  const { t } = useTranslation("home");
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    const apiUrl = import.meta.env.VITE_API_URL || "/api";
    // Soporte para apiUrl que xa rematan en /api ou só dominio
    const url = apiUrl.endsWith("/api") ? `${apiUrl}/banner` : `${apiUrl}/api/banner`;

    const load = async () => {
      try {
        const res = await fetch(url);
        if (!res.ok) return;
        const data = await res.json();
        if (cancelled) return;
        if (data?.text) {
          // Reset dismissed se cambia o contido (novo banner = volve a aparecer)
          const stored = sessionStorage.getItem("globalBannerDismissed");
          if (stored && stored !== data.text) {
            sessionStorage.removeItem("globalBannerDismissed");
            setDismissed(false);
          } else if (stored === data.text) {
            setDismissed(true);
          }
          setBanner(data);
        } else {
          setBanner(null);
        }
      } catch { /* silent */ }
    };

    load();
    const id = setInterval(load, 60_000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  if (!banner?.text || dismissed) return null;

  const sev = banner.severity || "info";
  const STYLES_BY_SEV = {
    info:     { bg: "bg-blue-50",    border: "border-blue-200",    text: "text-blue-900",    icon: Info,           iconColor: "text-blue-700" },
    warning:  { bg: "bg-yellow-50",  border: "border-yellow-200",  text: "text-yellow-900",  icon: AlertTriangle,  iconColor: "text-yellow-700" },
    critical: { bg: "bg-red-50",     border: "border-red-200",     text: "text-red-900",     icon: AlertTriangle,  iconColor: "text-red-700" },
  };
  const styles = STYLES_BY_SEV[sev] || STYLES_BY_SEV.info;
  const Icon = styles.icon;

  const handleDismiss = () => {
    sessionStorage.setItem("globalBannerDismissed", banner.text);
    setDismissed(true);
  };

  return (
    <div className={`${styles.bg} border-b ${styles.border}`}>
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3 text-sm">
        <Icon size={16} className={`${styles.iconColor} shrink-0`} />
        <p className={`flex-1 ${styles.text} leading-snug`}>{banner.text}</p>
        {sev !== "critical" && (
          <button
            onClick={handleDismiss}
            className={`shrink-0 p-1 ${styles.iconColor} hover:opacity-70 transition-opacity`}
            title={t("globalBanner.dismissTitle")}
          >
            <X size={14} />
          </button>
        )}
      </div>
    </div>
  );
}
